// AXIOS SETUP
// import swal from 'sweetalert2'
import axios from "axios"

import {notify} from "@/utils"
import { store } from "@/store-init"

const GeneralVersion = '0.0.0'; // Remoción de modal de detalle si la vista no está configurada para recetas.

// const Toast = swal.mixin({
// 	toast: true,
// 	position: 'top-end',
// 	showConfirmButton: false,
// 	grow: 'column',
// 	timer: 8000
// })

let api = 'apiMain',
	publicWebURI = 'https://supereasy.mx',
	apiURI,
	apiURIMain;

switch (api) {
	case 'docker': // DEV
		apiURI = 'http://localhost:8001/supereasyMX-api-dev/';
		break;
	case 'apiDev':	// PUBLIC TESTING
		apiURI = 'https://api.supereasy.mx/api-dev/';
		break;
	case 'apiTest':	// PUBLIC TESTING
		apiURI = 'https://api.supereasy.mx/api-test/';
		break;
	case 'apiMain': // MAIN-PRODUCTION
		apiURI = 'https://api.supereasy.mx/api-main/';
		break;
	case 'ngrok':
		apiURI = 'https://d77b3f9801a0.ngrok.app/supereasyMX-api-dev/';
		break;

}

apiURIMain = apiURI +  'index.php?r=';

axios.defaults.baseURL = apiURIMain + 'next';
axios.defaults.maediaImageRender = apiURIMain + 'img/render/';
axios.defaults.publicURL = 'http://supereasy.mx/';
axios.defaults.timeout = 30000

axios.interceptors.request.use((config) => {
	// Do something before request is sent
	config.headers['Content-Type'] = 'text/plain';
	if (store.getters.authToken)
		config.headers['auth-token'] = store.getters.authToken;
	return config;
}, (error) => {
	// Do something with request error
	return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use((response) => {

	// Do something with response data
	let processing = response.data;

	if (!!processing.class && processing.class == 'danger')
		processing.class = 'error';

	if (processing.msg) {
		notify( processing.msg, ((processing.class) ? processing.class : 'info'))
		// Toast.fire({
		// 	type: ((processing.class) ? processing.class : 'info'),
		// 	title: processing.msg
		// });
	}

	return processing;
}, (error) => {
	// Toast.fire({
	// 	type: 'error',
	// 	title: 'Error de servidor',
	// 	text: error.message
	// })
	notify(error.message, ('error'))
	return Promise.reject(error);
});

export {
	GeneralVersion,
	apiURI,	
	publicWebURI,
	apiURIMain
}